import axios from "axios";
import React, { useContext, useState } from "react";
import InfiniteScroll from "react-infinite-scroller";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import SpinnerGif from "../../assets/images/Spinner.gif";
import { _imagesURL, RecomendationApi } from "../../constants/API";
import { Language } from "../../App";
import { Link } from "react-router-dom";
import { PROFILE } from "../../constants/RoutesUrl";
import ImageComponent from "../common/ImageComponent";
import Avatar from "../../assets/images/icon/placeholder_Awatar.png";
import { authorize } from "../../shared/authorize";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import { MdOutlineMedicalServices } from "react-icons/md";
import { getProfileRoute, getUserSubtitle } from "../../utils/profileNavigator";
import "../feeds/sidebar/suggestedDoctors.css";

export default function ProfileSuggestionModal({
  preview,
  updatePreview,
  list,
  updateList,
  toFollow,
  loading,
}) {
  const { lang } = useContext(Language);

  const [hasMoreFollowing, setHasMoreFollowing] = useState(true);
  const [pagefollowing, setPagefollowing] = useState(1);

  const handleRecommendationList = () => {
    axios
      .get(
        RecomendationApi +
          "?page=" +
          JSON.stringify(pagefollowing + 1)
      ,authorize())
      .then((res) => {
        const updatedValue = res.data.data.data;
        updateList((prevData) => [...prevData, ...updatedValue]);
        setPagefollowing(pagefollowing + 1);

        if (res.data.data.current_page >= res.data.data.last_page) {
          setHasMoreFollowing(false);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <Modal
      scrollable
      centered
      zIndex={1060}
      isOpen={preview}
      toggle={updatePreview}
      backdrop="static"
      className="pf-modal"
    >
      <ModalHeader toggle={updatePreview} className="border-bottom-0 pb-0 pt-3 px-3.5">
        <div className="d-flex align-items-center gap-2">
          <div className="sd-icon-badge" style={{ width: "28px", height: "28px", borderRadius: "8px" }}>
            <MdOutlineMedicalServices size={15} />
          </div>
          <span style={{ color: "#0B132B", fontFamily: "'Onest', sans-serif", fontWeight: 600, fontSize: "16px" }}>
            {lang?.recommendations || "Suggested Doctors"}
          </span>
        </div>
      </ModalHeader>
      <ModalBody className="scroll-hide p-3">
        <InfiniteScroll
          pageStart={0}
          loadMore={handleRecommendationList}
          hasMore={hasMoreFollowing}
          loader={
            <div className="w-100 text-center py-2" key={0}>
              <img src={SpinnerGif} alt="..." width={30} height={30} />
            </div>
          }
          useWindow={false}
        >
          {list &&
            list.map((value, index) => (
              <React.Fragment key={value.id || index}>
                <div className="d-flex px-3 py-2.5 justify-content-between align-items-center feed-row-hover rounded-3 mb-1">
                  <Link
                    to={getProfileRoute(value)}
                    className="d-flex gap-3 align-items-center text-decoration-none text-dark flex-grow-1"
                    style={{ minWidth: 0 }}
                  >
                    <div
                      className="bg-white rounded-circle flex-shrink-0 position-relative"
                      style={{
                        padding: "2px",
                        width: "46px",
                        height: "46px",
                        border: "1.8px solid #00BADA",
                        boxShadow: "0px 2px 6px rgba(0, 186, 218, 0.15)",
                      }}
                    >
                      <ImageComponent
                        src={value?.image ? _imagesURL + value.image : Avatar}
                        compClassName="rounded-circle"
                        img_height="100%"
                        img_width="100%"
                        loader_height="100%"
                        loader_width="100%"
                        roundShimmerSize={42}
                      />
                      <div
                        style={{
                          position: "absolute",
                          bottom: "-2px",
                          right: "-2px",
                          width: "16px",
                          height: "16px",
                          borderRadius: "50%",
                          background: "#FFFFFF",
                          color: "#00BADA",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "11px",
                          boxShadow: "0 1px 4px rgba(0, 186, 218, 0.3)",
                        }}
                      >
                        <RiVerifiedBadgeFill />
                      </div>
                    </div>
                    <div className="d-flex flex-column" style={{ minWidth: 0 }}>
                      <p
                        className="fs-13 mb-0 text-truncate hover-blue"
                        style={{ color: "#0B132B", fontFamily: "'Onest', sans-serif", fontWeight: 600 }}
                      >
                        {value?.name}
                      </p>
                      <span
                        className="fs-11 text-truncate"
                        style={{ color: "#64748B", fontFamily: "'Onest', sans-serif" }}
                      >
                        {getUserSubtitle(value, lang)}
                      </span>
                    </div>
                  </Link>
                  <div className="align-self-center flex-shrink-0 ms-2">
                    <button
                      disabled={loading}
                      type="button"
                      className={`sd-follow-btn ${
                        value.follow ? "sd-follow-btn--following" : "sd-follow-btn--follow"
                      }`}
                      style={{
                        padding: "5px 14px",
                        fontSize: "12px",
                        width: "auto",
                        minWidth: "86px",
                      }}
                      onClick={() => {
                        toFollow(value.id);
                      }}
                    >
                      {value.follow ? lang?.following || "Following" : `+ ${lang?.follow || "Follow"}`}
                    </button>
                  </div>
                </div>
                {index !== list.length - 1 && (
                  <hr className="my-1" style={{ borderColor: "#F1F5F9", opacity: 0.8 }} />
                )}
              </React.Fragment>
            ))}
        </InfiniteScroll>
      </ModalBody>
    </Modal>
  );
}
